// extracted by mini-css-extract-plugin
export default {"welcome_box":"welcome_welcome_box__X-b98","welcome_title":"welcome_welcome_title__szlIp","welcome_text":"welcome_welcome_text__POsc8"};